import { render, staticRenderFns } from "./ConfirmationDataMobile.vue?vue&type=template&id=564394aa&scoped=true&"
import script from "./ConfirmationDataMobile.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmationDataMobile.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ConfirmationDataMobile.vue?vue&type=style&index=0&id=564394aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564394aa",
  null
  
)

export default component.exports